import { BaseProduct, ProductConfig } from "@utils/product/product-utils-types";
import { AllTrialProductTypes } from "@utils/product/product-types";
import { DateTimeUtils } from "@stellar/utils";
import { createProductsFromConfigs } from "@utils/product/product-utils";

const trial: Record<AllTrialProductTypes, ProductConfig> = {
  enterprise360PointCloudTrial: {
    scopesWithoutLimit: ["COMPANY"],
    identifiers: [
      "sphere-xg-enterprise",
      "sphere-xg-addon-360",
      "sphere-xg-addon-point-cloud",
      "sphere-xg-trial-indicator",
    ],
    name: "Point Cloud & 360° Trial",
    description: "The trial version of Point Cloud & 360° Enterprise",
    duration: {
      defaultDays: DateTimeUtils.DURATION.app.trialPeriodInDays,
      isFixed: false,
    },
    isCoreProduct: true,
    apps: ["holoBuilder", "sphereXg"],
  },
};

/** List of all available bundles in Admin Panel */
export const allAvailableTrialProducts: Record<
  AllTrialProductTypes,
  BaseProduct
> = createProductsFromConfigs(trial);
